import React, { useState, useEffect } from 'react';
import { JsBridge, HELPER } from 'utils';
import axios from 'axios';
import config from './TnCPage.page.config';
import text from './TnCPage.page.translation';
import './TnCPage.page.style.less';

const TnCPage = ({
  location: {
    state: { contentUrl },
  },
  setLoading,
  intl: { formatMessage },
}) => {
  const defaultContent = { en: '', id: '' };
  const [content, setContent] = useState(defaultContent);

  const decodeHtml = escapedHtml => {
    const unescapedHtml = unescape(escapedHtml);
    const fontFamilyNativeRegex = /font-family: Native Font;/g;

    return unescapedHtml
      .replace(fontFamilyNativeRegex, '')
      .split('px')
      .map((element, index, array) => {
        if (index < array.length - 1) {
          const word = element.split(' ');
          const fontSizeIndex = word.length - 1;

          const fontSize = (parseFloat(word[fontSizeIndex]) / 10).toString();
          word[fontSizeIndex] = `${fontSize}rem`;

          return word.join(' ');
        }
        return element;
      })
      .join('');
  };

  useEffect(() => {
    setLoading(true);
    JsBridge.setTitle(formatMessage(text.title));
    axios
      .get(contentUrl)
      .then(response => {
        setContent(response.data);
        setLoading(false);
      })
      .catch(() => {
        setContent(defaultContent);
        setLoading(false);
      });
  }, []);

  return (
    <div className="preview-tnc">
      <div
        className="content-tnc"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: decodeHtml(content[HELPER.getLang()]),
        }}
      ></div>
    </div>
  );
};

TnCPage.displayName = config.displayName;
TnCPage.defaultProps = config.defaultProps;
TnCPage.propTypes = config.propTypes;

export default TnCPage;
